import { styled } from '@mui/material/styles';
import { Select, InputLabel } from '@mui/material';

export const STPSelect = styled(Select)(({ theme }) => ({
  borderRadius: '20px',
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#50A579',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#50A579',
  },
  '&.Mui-focused': {
    backgroundColor: 'rgba(0, 128, 0, 0.1)',
  },
}));

export const STPInputLabel = styled(InputLabel)(({ theme }) => ({
  '&.Mui-focused': {
    color: '#50A579',
  },
}));